import React, { useContext } from 'react'
import { Color, CurrentUILocaleContext } from '../../utils'
import { IProps } from './index'

export const CloseButton = ({ onClick }: IProps) => {
  const { ui } = useContext(CurrentUILocaleContext)

  return (
    <button
      onClick={onClick}
      type="button"
      aria-label={ui.localize('CloseButton.ariaCloseButtonLabel')}
    >
      <svg
        width="32"
        height="28"
        viewBox="0 0 32 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 2.00003L28 26"
          stroke="#081D34"
          strokeWidth="2.47"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 26L28 1.99997"
          stroke="#081D34"
          strokeWidth="2.47"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <style jsx>
        {`
          button {
            cursor: pointer;
            user-select: none;
            display: block;
            outline: none;
          }

          .close-icon {
            fill: ${Color.Slate};
            vertical-align: middle; // Removes white space below.
          }

          button:focus .close-icon,
          button:hover .close-icon {
            fill: ${Color.Slate};
          }

          button:focus .close-icon {
            outline: 1px dotted ${Color.Slate};
            outline-offset: 3px;
          }
        `}
      </style>
    </button>
  )
}
